import {
    CATEGORIES_PATH
} from '@/common/constants'

import { createStore } from 'vuex'
import axios from 'axios'
import SerializeQuery from '@/common/mixin/SerializeQuery'

const store = {
    state: {
        categories: [],
        paginator: {
            limit: 10,
            count: 0,
            page: 1
        }
    },
    mutations: {
        SET_CATEGORIES (state, value) {
            state.categories = value
        },
        SET_PAGINATOR (state, value) {
            state.paginator = value
        },
        SET_PAGE (state, value) {
            state.paginator.page = value
        }
    },
    actions: {
        async PAGINATE (context, data) {
            const qs = SerializeQuery.methods.serialize_query(data)
            let result
            try {
                result = await axios.get(`${CATEGORIES_PATH}?${qs}`)
            } catch (error) {
                return error.response
            }

            context.commit('SET_CATEGORIES', result.data.items)
            context.commit('SET_PAGINATOR', {
                limit: result.data.limit,
                count: result.data.count,
                page: result.data.page
            })
        },
        async CREATE (context, data) {
            let response = {}
            try {
                response = await axios.post(`${CATEGORIES_PATH}`, data)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response
            }
            return response
        },
        async UPDATE (context, data) {
            let response = {}
            try {
                response = await axios.put(`${CATEGORIES_PATH}/${data.id}`, data.params)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response
            }
            return response
        },
        async DELETE_CATEGORY (context, data) {
            let response = {}
            try {
                response = await axios.delete(`${CATEGORIES_PATH}/${data.category_id}`)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response.data
            }
            return response.data
        }
    },
    strict: !import.meta.env.PROD
}

export default createStore(store)
